import { authedJson } from './client';
import config from '../config';
import { API_ROUTES } from '../../../shared/api';
import type { Deck, DeckSummary, UpsertDeckBody } from '../../../shared/types';

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

/**
 * Deck endpoints. Create/list/update/delete require auth. GET by id is public
 * (the server gates private decks) but we still pass the token so an owner can
 * view their own private deck.
 */
export const decksApi = {
  listMine: (getToken: GetToken, refresh: DoRefresh) =>
    authedJson<DeckSummary[]>(API_ROUTES.decks, { method: 'GET' }, getToken, refresh),

  /** Public deck discovery — no auth required. */
  listPublic: () =>
    fetch(`${config.apiUrl}${API_ROUTES.decksPublic}`).then(async r => {
      if (!r.ok) throw new Error(`Request failed (${r.status})`);
      return (await r.json()) as DeckSummary[];
    }),

  create: (body: UpsertDeckBody, getToken: GetToken, refresh: DoRefresh) =>
    authedJson<Deck>(API_ROUTES.decks, { method: 'POST', body: JSON.stringify(body) }, getToken, refresh),

  get: (id: string, getToken: GetToken, refresh: DoRefresh) =>
    authedJson<Deck>(API_ROUTES.deck(id), { method: 'GET' }, getToken, refresh),

  update: (id: string, body: UpsertDeckBody, getToken: GetToken, refresh: DoRefresh) =>
    authedJson<Deck>(API_ROUTES.deck(id), { method: 'PUT', body: JSON.stringify(body) }, getToken, refresh),

  remove: (id: string, getToken: GetToken, refresh: DoRefresh) =>
    authedJson<void>(API_ROUTES.deck(id), { method: 'DELETE' }, getToken, refresh),
};
